// extracted by mini-css-extract-plugin
export default {"banner":"Banner_banner__mSOMT","bannerIn":"Banner_bannerIn__QoMR0","bannerNumText":"Banner_bannerNumText__sD4JW","bannerBtn":"Banner_bannerBtn__Hm83J"};